<template>
    <!-- Componente para mostrar los nuevos servicios de mantenimiento -->
    <div>
        <div class="price w-9/12 mx-auto lg:flex">
            <div class="form-group mb-5 lg:w-5/12 lg:mr-6">
                <label class="text-xs block" for="model">Modelo:</label>
                <select
                    class="w-full text-base sm:text-lg lg:text-base h-10 appearance-none bg-no-repeat bg-light-brown border-solid border-b border-black"
                    :style="`background-image: url('${url}/images/services/appointment/down_arrow_icon.png'); background-size: 0.8rem; background-position: 100%; text-indent: 0;`"
                    name="model"
                    id="model"
                    v-model="model"
                >
                    <option value="" disabled>-Selecciona un modelo-</option>
                    <option v-for="(item, index) in maintenanceServices" :key="item.id" :value="index">
                        {{ item.name }}
                    </option>
                </select>
            </div>
            <div class="form-group mb-5 lg:w-5/12 lg:mr-6">
                <label class="text-xs block" for="km_months">KM / Meses:</label>
                <select
                    class="w-full text-base sm:text-lg lg:text-base h-10 appearance-none bg-no-repeat bg-light-brown border-solid border-b border-black"
                    :style="`background-image: url('${url}/images/services/appointment/down_arrow_icon.png'); background-size: 0.8rem; background-position: 100%; text-indent: 0;`"
                    name="km_months"
                    id="km_months"
                    v-model="service"
                >
                    <option value="" disabled>-Selecciona una opción-</option>
                    <option v-for="(service, index) in services" :key="service.id" :value="index">
                        {{ service.name }}
                    </option>
                </select>
            </div>
            <div class="flex flex-col lg:flex-row gap-2">
                <p
                    class="w-full lg:w-32 lg:h-10 bg-dark-blue py-1 lg:py-2 text-white text-center text-xl sm:text-2xl lg:text-lg lg:mt-4"
                >
                    ${{ formatPrice(servicePrice) }}
                </p>

                <a
                    v-if="whatsapp?.active"
                    class="w-full lg:w-32 lg:h-10 bg-dark-blue py-1 lg:py-2 text-white text-center text-xl sm:text-2xl lg:text-lg lg:mt-4"
                    :href="`https://wa.me/${whatsapp.value}`"
                    target="_blank"
                    >WhatsApp
                </a>
            </div>
        </div>
        <div v-show="showServices" class="lg:flex lg:w-9/12 lg:mx-auto mt-4 sm:mt-6 lg:mt-4 lg:justify-between">
            <div class="inspection w-10/12 sm:w-8/12 lg:w-1/2 lg:mr-6 mx-auto lg:mx-0 bg-white">
                <h3
                    class="font-bold text-xl sm:text-2xl lg:text-xl text-center py-3 border-solid border-b border-light-gray"
                >
                    Inspección
                </h3>
                <div class="list w-8/12 sm:w-7/12 mx-auto pt-6 pb-8">
                    <div class="overflow-y-auto h-56 sm:h-64 lg:h-48 text-base sm:text-lg lg:text-base leading-snug">
                        <p v-for="inspection in serviceSelected.inspections" :key="inspection.id">
                            · {{ inspection.activity }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="change w-10/12 sm:w-8/12 lg:w-1/2 mx-auto lg:mx-0 bg-white mt-4 lg:mt-0">
                <h3
                    class="font-bold text-xl sm:text-2xl lg:text-xl text-center py-3 border-solid border-b border-light-gray"
                >
                    Cambio
                </h3>
                <div class="list w-8/12 sm:w-7/12 mx-auto pt-6 pb-8">
                    <div class="overflow-y-auto h-32 lg:h-48 sm:h-40 text-base sm:text-lg lg:text-base leading-snug">
                        <p v-for="replacement in serviceSelected.replacements" :key="replacement.id">
                            · {{ replacement.activity }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["maintenanceServices", "whatsapp"],
    data() {
        return {
            url: $(".url").text(),
            // Variable para almacenar el modelo seleccionado
            model: "",
            // Variable para almacenar el servicio seleccionado
            service: "",
            // serviceSelected: {}
        };
    },
    watch: {
        // Observa la variable model para reestablecer el
        // servicio seleccionado en caso de que cambie el modelo
        model: function (val) {
            this.service = "";
        },
        // service: function(val) {
        //     this.serviceSelected = this.maintenanceServices[this.model].maintenance_services[val]
        // }
    },
    methods: {
        // Función para formatear el precio
        formatPrice(price) {
            return parseInt(price)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        },
    },
    computed: {
        // Retorna los servicios correspondientes con
        // el modelo seleccionado
        services() {
            return this.model !== "" ? this.maintenanceServices[this.model].maintenance_services : [];
        },
        // Retorna el precio del servicio seleccionado
        servicePrice() {
            return this.service !== ""
                ? this.maintenanceServices[this.model].maintenance_services[this.service].price
                : 0;
        },
        // Retorna un valor booleano para determinar
        // si mostrar o no los servicios de mantenimiento
        showServices() {
            return !$.isEmptyObject(this.serviceSelected);
        },
        // Retorna el objeto del servicio seleccionado
        serviceSelected() {
            return this.service !== "" ? this.maintenanceServices[this.model].maintenance_services[this.service] : {};
        },
    },
    created() {
        // Escucha el evento emitido desde el componente del
        // formulario de cita de servicio para mostrar los servicios
        // correspondientes de acuerdo al modelo seleccionado en el formulario
        this.$eventBus.$on("iframe-appointment-message", (data) => {
            console.log("iframe-appointment-message", data);
            this.model = this.maintenanceServices.findIndex((item) => item.name === data.modelo);
            this.$nextTick(() => {
                this.service = this.maintenanceServices[this.model].maintenance_services.findIndex(
                    (service) => service.name.replace(".", "") === data.kilometrosMeses.replace(".", ""),
                );
            });
        });
    },
    beforeDestroy() {
        this.$eventBus.$off("iframe-appointment-message");
    },
};
</script>
